export var ScreenWidthKeys;
(function (ScreenWidthKeys) {
    ScreenWidthKeys["EXTRA_EXTRA_SMALL"] = "EXTRA_EXTRA_SMALL";
    ScreenWidthKeys["EXTRA_SMALL"] = "EXTRA_SMALL";
    ScreenWidthKeys["SMALL"] = "SMALL";
    ScreenWidthKeys["MEDIUM"] = "MEDIUM";
    ScreenWidthKeys["LARGE"] = "LARGE";
    ScreenWidthKeys["EXTRA_LARGE"] = "EXTRA_LARGE";
})(ScreenWidthKeys || (ScreenWidthKeys = {}));
export var ScreenWidth;
(function (ScreenWidth) {
    ScreenWidth["EXTRA_EXTRA_SMALL"] = "376px";
    ScreenWidth["EXTRA_SMALL"] = "576px";
    ScreenWidth["SMALL"] = "768px";
    ScreenWidth["MEDIUM"] = "992px";
    ScreenWidth["LARGE"] = "1200px";
    ScreenWidth["EXTRA_LARGE"] = "2400px";
})(ScreenWidth || (ScreenWidth = {}));
export const ScreenWidthValues = {
    [ScreenWidth.EXTRA_EXTRA_SMALL]: 376,
    [ScreenWidth.EXTRA_SMALL]: 576,
    [ScreenWidth.SMALL]: 768,
    [ScreenWidth.MEDIUM]: 992,
    [ScreenWidth.LARGE]: 1200,
    [ScreenWidth.EXTRA_LARGE]: 2400,
};
export const MediaQueries = {
    EXTRA_EXTRA_SMALL: `@media (max-width: ${ScreenWidth.EXTRA_EXTRA_SMALL})`,
    EXTRA_SMALL: `@media (max-width: ${ScreenWidth.EXTRA_SMALL})`,
    SMALL: `@media (max-width: ${ScreenWidth.SMALL})`,
    MEDIUM: `@media (max-width: ${ScreenWidth.MEDIUM})`,
    LARGE: `@media (max-width: ${ScreenWidth.LARGE})`,
    EXTRA_LARGE: `@media (max-width: ${ScreenWidth.EXTRA_LARGE})`,
};
//# sourceMappingURL=screenWidth.js.map